import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const posRoutes: RouteRecordRaw[] = [
  {
    path: '/pos',
    name: ROUTES.POS_NEW_ORDER,
    component: () => import('@/modules/pos/PointOfSale.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: {
      roles: ACTION_ROLES.POS_NEW_ORDER_VIEW,
      fullWidthLayout: true,
      showRecentOrders: true,
      showStatusBadges: true,
      whiteBackground: true,
      collapsibleSidebar: true,
      displayName: 'Point-of-sale'
    }
  }
]
